import { getDomainUrl } from 'coreOld/utils';

export const termsOfServicePath = () => `${getDomainUrl()}/agreement`;
export const privatePolicyPath = () => `${getDomainUrl()}/privacy`;
